<template>
    <div class="animated fadeIn">
      <b-row>
        <b-col sm="12">
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
              <strong>Vendor Zone Management</strong>
              <div class="card-header-actions">
                <b-button
                  size="sm"
                  class="btn btn-sm btn-primary mr-4 "
                  data-toggle="tooltip"
                  variant="primary"
                  @click="addNewZone()"
                  >Add Vendor Zone</b-button
                >
              </div>
            </div>
  
            <div>
              <b-collapse id="Zone">
                <b-card>
                  <b-form
                    @submit.prevent="validateForm('form-1')"
                    data-vv-scope="form-1"
                  >
                    <b-col md="12">
                      <b-row>
                        <b-col sm="6">
                          <b-form-group label="Vendor Zone Name :" :label-cols="4">
                            <b-form-input
                              class="input"
                              type="text"
                              v-model="Customer.zone_name"
                              name="Zone_name"
                              v-validate="'required|alpha_spaces'"
                              :class="{
                                input: true,
                                'text-danger': errors.has('form-1.Zone_name'),
                              }"
                              placeholder="Enter Vendor Zone Name"
                            >
                            </b-form-input>
                            <b-input-group class="mt-2">
                              <span class="icon has-text-warning">
                                <i
                                  class="fa fa-warning help text-danger"
                                  v-show="errors.has('form-1.Zone_name')"
                                  >{{ errors.first("form-1.Zone_name") }}</i
                                >
                              </span>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
  
                        <b-col sm="6">
                          <b-form-group label="Vendor Zone Number :" :label-cols="4">
                            <b-form-input
                              class="input"
                              type="text"
                              v-model="Customer.zone_number"
                              name="Zone_number"
                              v-validate="'required|numeric'"
                              :class="{
                                input: true,
                                'text-danger': errors.has('form-1.Zone_number'),
                              }"
                              placeholder="Enter Vendor Zone Number"
                            >
                            </b-form-input>
                            <b-input-group class="mt-2">
                              <span class="icon has-text-warning">
                                <i
                                  class="fa fa-warning help text-danger"
                                  v-show="errors.has('form-1.Zone_number')"
                                  >{{ errors.first("form-1.Zone_number") }}</i
                                >
                              </span>
                            </b-input-group>
                          </b-form-group>
                        </b-col>

                        <b-col sm="12">
                          <b-form-group label="Select Type :" :label-cols="2">
                            <b-form-radio-group
                              v-model="Customer.selectedredio"
                              :options="options"
                              class="mt-2"
                              value-field="item"
                              text-field="name"
                              disabled-field="notEnabled"
                              name="Zone_check"
                              v-validate="'required'"
                              :class="{
                                input: true,
                                'text-danger': errors.has('form-1.Zone_check'),
                              }"
                            >
                            </b-form-radio-group>
                            <b-input-group class="mt-2">
                              <span class="icon has-text-warning">
                                <i
                                  class="fa fa-warning help text-danger"
                                  v-show="errors.has('form-1.Zone_check')"
                                  >{{ errors.first("form-1.Zone_check") }}</i
                                >
                              </span>
                            </b-input-group>
                          </b-form-group>
                        </b-col>

                        <b-col sm="12">
                          <!-- <b-form-group label="Is Vendor Hub :" :label-cols="2"> -->
                            <b-form-radio-group
                              v-model="Customer.selected_redio"
                              :options="huboptions"
                              class="mt-2 selectbutton"
                              value-field="item"
                              text-field="name"
                              disabled-field="notEnabled"
                              name="vendorZone_check"
                              v-validate="'required'"
                              :class="{
                                input: true,
                                'text-danger': errors.has('form-1.vendorZone_check'),
                              }"
                            >
                            </b-form-radio-group>
                            <b-input-group class="mt-2">
                              <span class="icon has-text-warning">
                                <i
                                  class="fa fa-warning help text-danger"
                                  v-show="errors.has('form-1.vendorZone_check')"
                                  >{{ errors.first("form-1.vendorZone_check") }}</i
                                >
                              </span>
                            </b-input-group>
                          <!-- </b-form-group> -->
                        </b-col>

                        <b-col sm="6"  class="mt-4">
                          <b-form-group label="Map Zone To City :" :label-cols="4">
                            <b-form-select v-model="selected_mapcity" :options="mapoptions"></b-form-select>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-col>
  
                    <footer class="column has-text-right">
                      <b-button
                        variant="primary"
                        size="md"
                        type="submit"
                        style="float: right;"
                        >ADD</b-button
                      >
                    </footer>
                  </b-form>
                </b-card>
              </b-collapse>
            </div>
  
            <b-row>
              <b-col sm="12" class="text-right  " >
                  <b>Total Records :<span style="color:red;">{{ totalRows }}</span></b> 
              </b-col>
              <b-col md="12">
                <b-table
                  show-empty
                  responsive
                  :items="zonelist"
                  :busy="isBusy"
                  :current-page="currentPage"
                  :fields="fields"
                  :per-page="perPage"
                  :filter="filter"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection"
                  :bordered="bordered"
                >
                  <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                  <template slot="Action" slot-scope="row">
                    <!-- <b-row>
                      <b-col sm="12"> -->
                          <div>
                        <input
                          @change="setStickerHTMl($event, row.item)"
                          type="radio"
                          name="radAnswer"
                          v-model="row.item.selected"
                          class="shipmentscheckbox"
                          id="stiker"
                          :checked="checkedData"
                        />&nbsp;
                      <!-- </b-col> -->
                      <!-- <b-col> -->
                        <b-button
                          id="printbuttons"
                          variant="primary"
                          size="sm"
                          value="print a div!"
                          @click="barcodedata('printableArea', row.item)"
                          style="background: #b0c4de !important;color: #000 !important;"
                          >Print Zone
                        </b-button>&nbsp;
                      <!-- </b-col> -->
                      <!-- <b-col> -->
                        <b-button
                          v-if="row.item.zonetype == 'Normal'"
                          variant="primary"
                          size="sm"
                          v-b-modal.modal-1
                          style="background: #b0c4de !important;color: #000 !important; "
                          @click="Openpallet(row.item)"
                          >Add Pallet
                        </b-button>
                      </div>
                      <!-- </b-col>
                    </b-row> -->
                  </template>
                </b-table>
              </b-col>
            </b-row>
  
            <div id="printableArea">
              <div class="page-break" v-for="zone in zoneArr">
                <div style="font-size: 25px;">
                  <b>{{ zone.zone_title }} -- {{zone.zone_no}}</b>
                </div>
                <!-- <br> -->
                <br />
                <qr-code :text="zone.zone_id"></qr-code>
              </div>
            </div>
  
            <!-- Pallet -->
            <div>
              <b-modal
                id="modal-1"
                title="Add Pallet"
                size="xl"
                v-model="showpalletdetails"
                @ok="showpalletdetails = false"
                hide-footer
              >
                <b-row>
                  <b-col v-if="User_type == 2" style="display: block;">
                    <b-button
                      size="sm"
                      class="btn btn-sm btn-primary mr-4"
                      style="float: right; margin: 0px 0px 15px 0px;"
                      data-toggle="tooltip"
                      variant="primary"
                      @click="addZonePallet()"
                      >Add Pallet</b-button
                    >
                  </b-col>
                </b-row>
  
                <div>
                  <b-collapse id="Pallet">
                    <b-card>
                      <b-form
                        @submit.prevent="validateForm1('form-2')"
                        data-vv-scope="form-2"
                      >
                        <b-col md="12">
                          <b-row>
                            <b-col sm="6">
                              <b-form-group label="Pallet Name :" :label-cols="3">
                                <b-form-input
                                  class="input"
                                  type="text"
                                  v-model="Users.pallet_name"
                                  name="Pallet_name"
                                  v-validate="'required|alpha_spaces'"
                                  :class="{
                                    input: true,
                                    'text-danger': errors.has(
                                      'form-2.Pallet_name'
                                    ),
                                  }"
                                  placeholder="Enter Pallet Name"
                                >
                                </b-form-input>
                                <b-input-group class="mt-2">
                                  <span class="icon has-text-warning">
                                    <i
                                      class="fa fa-warning help text-danger"
                                      v-show="errors.has('form-2.Pallet_name')"
                                      >{{ errors.first("form-2.Pallet_name") }}</i
                                    >
                                  </span>
                                </b-input-group>
                              </b-form-group>
                            </b-col>
  
                            <b-col sm="6">
                              <b-form-group
                                label="Pallet Number :"
                                :label-cols="3"
                              >
                                <b-form-input
                                  class="input"
                                  type="text"
                                  v-model="Users.pallet_number"
                                  name="Pallet_number"
                                  v-validate="'required|numeric'"
                                  :class="{
                                    input: true,
                                    'text-danger': errors.has(
                                      'form-2.Pallet_number'
                                    ),
                                  }"
                                  placeholder="Enter Pallet Number"
                                >
                                </b-form-input>
                                <b-input-group class="mt-2">
                                  <span class="icon has-text-warning">
                                    <i
                                      class="fa fa-warning help text-danger"
                                      v-show="errors.has('form-2.Pallet_number')"
                                      >{{
                                        errors.first("form-2.Pallet_number")
                                      }}</i
                                    >
                                  </span>
                                </b-input-group>
                              </b-form-group>
                            </b-col>
                          </b-row>
                        </b-col>
  
                        <footer class="column has-text-right">
                          <b-button
                            variant="primary"
                            size="md"
                            type="submit"
                            style="float: right;"
                            >ADD</b-button
                          >
                        </footer>
                        <div id="overlayModal">
                    <div class="loaderModal"></div>
                  </div>
                      </b-form>
                    </b-card>
                  </b-collapse>
                </div>
  
                <b-row>
                  <b-col sm="12" class="text-right  " >
                  <b>Total Records :<span style="color:red;">{{ pallettotalRows }}</span></b> 
                   </b-col>
                  <b-col md="12">
                    <b-table
                      show-empty
                      responsive
                      :items="palletlist"
                      :busy="isBusypallet"
                      :current-page="currentPagePallet"
                      :fields="fieldsPallet"
                      :per-page="perPagePallet"
                      :filter="filter"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :sort-direction="sortDirection"
                      :bordered="bordered"
                    >
                      <div slot="table-busy" class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                      <template slot="Action" slot-scope="row">
                        <input
                          @change="setpalletStickerHTMl($event, row.item)"
                          type="radio"
                          name="radAnswer"
                          v-model="row.item.selected"
                          class="shipmentscheckbox"
                          id="stiker"
                          :checked="checkedpalletData"
                        />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
  
                        <b-button
                          id="printbutton"
                          variant="primary"
                          size="sm"
                          value="print a div!"
                          @click="
                            barcodepalletdata('printablePalletArea', row.item)
                          "
                          style="background: #b0c4de !important;color: #000 !important;"
                          >Print Pallet </b-button
                        >&nbsp;&nbsp;
                      </template>
                    </b-table>
                  </b-col>
                </b-row>
  
                <div id="printablePalletArea">
                  <div class="page-break" v-for="pallet in palletArr">
                    <div style="font-size: 25px;">
                      <b>{{ pallet.pallet_title }}</b>
                    </div>
                    <!-- <br> -->
                    <br />
                    <qr-code :text="pallet.pallet_id"></qr-code>
                  </div>
                </div>
              </b-modal>
            </div>
            <!-- END Pallet -->
          </b-card>
        </b-col>
      </b-row>
    </div>
  </template>
  
  <script>
  import CONSTANTS from "@/utils/constants";
  import Utils from "@/utils";
  import Vue from "vue";
  import QrcodeVue from "qrcode.vue";
  export default {
    data() {
      return {
        Customer: {},
        zonelist: [],
        fields: [
          { key: "zoneid", label: "Zone Id", sortable: true },
          { key: "zone_title", label: "Zone Name", sortable: true },
          { key: "zone_no", label: "Zone Number", sortable: true },
          { key: "created_date", label: "Created Date", sortable: true },
          { key: "created_by", label: "Created By", sortable: true },
          { key: "Action", label: "Action", sortable: true },
        ],
        isBusy: false,
        qrdetail: [],
        QRcodezone_id: "",
        QRcodezone_title: "",
        checkedData: false,
        zoneArr: [],
        selected_zone_id: "",
        QrcodeVue,
        // selectedredio : '',
        options: [
          { item: "Dock", name: "Dock" },
          { item: "Normal", name: "Normal" },
        ],
        huboptions: [
          { item: "is_vendor_hub", name: "Is Vendor Hub" },
          { item: "is_b2c_zone", name: "Is B2C Zone" },
        ],
        selected_mapcity:'',
        mapoptions: [
          { value: '', text: 'Please select an option' },
          { value: 'a', text: 'This is First option' },
          { value: 'b', text: 'Selected Option' },
          { value: { C: '3PO' }, text: 'This is an option with object value' },
          { value: 'd', text: 'This one is disabled', disabled: true }
        ],
        Users: {},
        isBusypallet:false,
        palletlist: [],
        fieldsPallet: [
          { key: "pallet_id", label: "Pallet Id", sortable: true },
          { key: "pallet_title", label: "Pallet Name", sortable: true },
          { key: "pallet_no", label: "Pallet Number", sortable: true },
          { key: "created_date", label: "Created Date", sortable: true },
          { key: "created_by", label: "Created By", sortable: true },
          { key: "Action", label: "Action", sortable: true },
        ],
        selectedpalletdata: [],
        showpalletdetails: false,
        checkedpalletData: false,
        palletArr: [],
        selected_pallet_id: "",
        zone_type: "",
        User_type: "",
        totalRows:0,
        pallettotalRows:0,
      };
    },
    components: {
      QrcodeVue,
    },
    created() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      this.User_type = userInfo.user_type;
      console.log("userInfo", this.User_type);
      this.ZoneListings();
    },
  
    methods: {
      addNewZone: function() {
        // alert("ok");
        document.getElementById("Zone").style.display = "block";
      },
  
      validateForm(scope) {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.addZoneForm();
          }
        });
      },
  
      addZoneForm: function() {
        // alert("ok")
        document.getElementById("overlay").style.display = "block";
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
  
        const zoneObj = {
          creatersysusermasterid: `${userInfo.sysusermasterid}`,
          zonetitle: `${this.Customer.zone_name}`,
          zoneno: `${this.Customer.zone_number}`,
          createdby:
            `${userInfo.userfirstname}` + "" + `${userInfo.userlastname}`,
          zonetype: `${this.Customer.selectedredio}`,
          hub_id: userInfo.hub_id != null ? `${userInfo.hub_id}` : '',
        };
        console.log("zoneObj", zoneObj);
        // return false;
        // if (this.getPincodes.length !=0) {
        this.$http
          .post(`${CONSTANTS.MIGRATION_API_URL}/createNewZone`, zoneObj)
          .then((result) => {
            // alert("Api")
            document.getElementById("overlay").style.display = "none";
            if (result.body.returnmsg === "Successful") {
              this.$fire({
                text: "Added Successfully",
                type: "success",
                timer: 30000,
              });
              this.ZoneListings();
              this.Customer = {};
              this.errors.clear("form-1");
              document.getElementById("Zone").style.display = "none";
            } else {
              this.$fire({
                text: result.body.returnvalue,
                type: "error",
                timer: 30000,
              });
            }
          })
          .catch((ex) => {
            console.log("error", ex);
          });
        // }else{
        //     this.$fire({
        //                 text:"Please Enter Valid PinCode ",
        //                 type: "error",
        //                 timer: 30000
        //             });
        // }
      },
  
      ZoneListings: function() {
        this.isBusy = true;
        let userdata = localStorage.getItem("userData");
        let userInfo = JSON.parse(userdata);
        const obj = {
          sysusermasterid: `${userInfo.sysusermasterid}`,
          usertype: `${userInfo.user_type}`,
        };
        this.$http
          .post(`${CONSTANTS.MIGRATION_API_URL}/getAdminZoneListing`, obj)
          .then((result) => {
            this.isBusy = false;
  
            if (result.body.returnmsg === "Successful") {
              this.zonelist = result.body.returnvalue;    
              this.totalRows = result.body.returnvalue.length;
            } else {
              this.zonelist = [];
              this.totalRows = 0;
            }
          })
          .catch((ex) => {
            console.log("error", ex);
          });
      },
  
      barcodedata(printableArea, value) {
        if (this.checkedData == true && this.selected_zone_id == value.zoneid) {
          var printContents = document.getElementById("printableArea").innerHTML;
          // alert(printContents)
          var disp_setting = "toolbar=yes,location=no,";
          disp_setting += "directories=yes,menubar=yes,";
          disp_setting +=
            "scrollbars=yes,width=650, height=600, left=100, top=25";
          var content_vlue = printContents;
          var docprint = window.open("", "", disp_setting);
          docprint.document.open();
          docprint.document.write(
            '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"'
          );
          docprint.document.write(
            '"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">'
          );
          docprint.document.write(
            '<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">'
          );
          docprint.document.write("<head>");
          docprint.document.write('<style type="text/css">body{ margin:0px;');
          docprint.document.write("font-family:verdana,Arial;color:#000;");
          docprint.document.write(
            "font-family:Verdana, Geneva, sans-serif; font-size:20px;}"
          );
          docprint.document.write("a{color:#000;text-decoration:none;} ");
          docprint.document.write(
            ".stickertable{ border-collapse: collapse;margin-bottom: 20px; width:540px;height:540px} "
          );
          docprint.document.write(
            ".printarea{ font-size: 30px;text-align: center;}"
          );
  
          docprint.document.write(".addpad{ padding: 10px; }");
          docprint.document.write(
            "@media all { .page-break { display: block;vertical-align: middle;margin-top:20px; }}"
          );
          docprint.document.write(
            "@media print { .page-break { display: block; page-break-before: always; }}  @page { size: auto;  margin: 0mm; }"
          );
          docprint.document.write(".stickertable td{ padding-bottom:10px;  }");
          docprint.document.write("@page { size: 101.6mm 152.4mm;}</style>");
          docprint.document.write('</head><body onLoad="self.print()"><center>');
          docprint.document.write(content_vlue);
          docprint.document.write("</center></body></html>");
          docprint.document.close();
        } else {
          this.$fire({
            text: "Please Select Check Box",
            type: "warning",
            timer: 30000,
          });
        }
      },
  
      setStickerHTMl(e, value) {
        // console.log("ggggg",value)
        this.zoneArr = [];
        this.checkedData = true;
        this.selected_zone_id = value.zoneid;
        // console.log("Valueeeeeeeeeeeeeeee", this.selected_zone_id);
        const obj = {
          zone_id: `${value.zoneid}`,
          zone_title: value.zone_title,
          zone_no: value.zone_no,
        };
        this.zoneArr.push(obj);
        console.log("Titlwwwwww", this.zoneArr);
      },
  
      //pallet start
      addZonePallet() {
        // alert("ok")
        document.getElementById("Pallet").style.display = "block";
      },
  
      validateForm1(scope) {
        // alert("ok")
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.addPalletForm();
          }
        });
      },
  
      addPalletForm: function() {
        document.getElementById("overlayModal").style.display = "block";
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
  
        const PalletObj = {
          creatersysusermasterid: `${userInfo.sysusermasterid}`,
          pallettitle: `${this.Users.pallet_name}`,
          palletno: `${this.Users.pallet_number}`,
          createdby:
            `${userInfo.userfirstname}` + "" + `${userInfo.userlastname}`,
          zoneid: `${this.selected_palletzone_id}`,
          hub_id : `${userInfo.hub_id}`,
        };
        console.log("PalletObj", PalletObj);
        // return false;
        this.$http
          .post(`${CONSTANTS.MIGRATION_API_URL}/createNewPallet`, PalletObj)
          .then((result) => {
            // alert("Api")
            document.getElementById("overlayModal").style.display = "none";
            if (result.body.returnmsg === "Successful") {
              this.$fire({
                text: "Added Successfully",
                type: "success",
                timer: 30000,
              });
              this.PalletListing();
              this.Users = {};
              this.errors.clear("form-2");
              document.getElementById("Pallet").style.display = "none";
            } else {
              this.$fire({
                text: result.body.returnvalue,
                type: "error",
                timer: 30000,
              });
            }
          })
          .catch((ex) => {
            console.log("error", ex);
          });
      },
  
      Openpallet: function(data) {
        // alert("o")
        console.log("data", data);
        this.selectedpalletdata = data;
        this.selected_palletzone_id = data.zoneid;
      //   console.log("selected_palletzone_id", this.selected_palletzone_id);
        this.PalletListing();
        this.showpalletdetails = true;
      },
  
      PalletListing: function() {
        this.isBusypallet = true;
        let userdata = localStorage.getItem("userData");
        let userInfo = JSON.parse(userdata);
        const obj = {
          sysusermasterid: `${userInfo.sysusermasterid}`,
          zoneid: `${this.selected_palletzone_id}`,
        };
        this.$http
          .post(`${CONSTANTS.MIGRATION_API_URL}/getPalletListing`, obj)
          .then((result) => {
            this.isBusypallet = false;
            console.log("result", result);
            if (result.body.returnmsg === "Successful") {
              // alert("ok")
              this.palletlist = result.body.returnvalue;
              // console.log("palletlist", this.palletlist);
              this.pallettotalRows = result.body.returnvalue.length;
            } else {
              this.palletlist = [];
              this.pallettotalRows = 0;
            }
          })
          .catch((ex) => {
            console.log("error", ex);
          });
      },
  
      barcodepalletdata(printablePalletArea, value) {
        if (
          this.checkedpalletData == true &&
          this.selected_pallet_id == value.pallet_id
        ) {
          var printContents = document.getElementById("printablePalletArea")
            .innerHTML;
          // alert(printContents)
          var disp_setting = "toolbar=yes,location=no,";
          disp_setting += "directories=yes,menubar=yes,";
          disp_setting +=
            "scrollbars=yes,width=650, height=600, left=100, top=25";
          var content_vlue = printContents;
          var docprint = window.open("", "", disp_setting);
          docprint.document.open();
          docprint.document.write(
            '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"'
          );
          docprint.document.write(
            '"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">'
          );
          docprint.document.write(
            '<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">'
          );
          docprint.document.write("<head>");
          docprint.document.write('<style type="text/css">body{ margin:0px;');
          docprint.document.write("font-family:verdana,Arial;color:#000;");
          docprint.document.write(
            "font-family:Verdana, Geneva, sans-serif; font-size:20px;}"
          );
          docprint.document.write("a{color:#000;text-decoration:none;} ");
          docprint.document.write(
            ".stickertable{ border-collapse: collapse;margin-bottom: 20px; width:540px;height:540px} "
          );
          docprint.document.write(
            ".printarea{ font-size: 30px;text-align: center;}"
          );
  
          docprint.document.write(".addpad{ padding: 10px; }");
          docprint.document.write(
            "@media all { .page-break { display: block;vertical-align: middle;margin-top:20px; }}"
          );
          docprint.document.write(
            "@media print { .page-break { display: block; page-break-before: always; }}  @page { size: auto;  margin: 0mm; }"
          );
          docprint.document.write(".stickertable td{ padding-bottom:10px;  }");
          docprint.document.write("@page { size: 101.6mm 152.4mm;}</style>");
          docprint.document.write('</head><body onLoad="self.print()"><center>');
          docprint.document.write(content_vlue);
          docprint.document.write("</center></body></html>");
          docprint.document.close();
        } else {
          this.$fire({
            text: "Please Select Check Box",
            type: "warning",
            timer: 30000,
          });
        }
      },
  
      setpalletStickerHTMl(e, value) {
        // alert(value)
        this.palletArr = [];
        this.checkedpalletData = true;
        this.selected_pallet_id = value.pallet_id;
        // console.log("Valueeeeeeeeeeeeeeee", this.selected_zone_id);
        const obj = {
          pallet_id: `${value.pallet_id}`,
          pallet_title: value.pallet_title,
        };
        this.palletArr.push(obj);
        console.log("TitlwwwwwwpalletArr", this.palletArr);
      },
    },
  };
  </script>

<style>
.selectbutton span {
  font-weight: 599 !important;
}
</style>
  